import React from 'react';
import PropTypes from 'prop-types';
import renderRoutes from 'react-router-config/renderRoutes';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import get from 'lodash/get';

import getRoutesWithStore from '../../react_router/react_router';
import Head from '../components/head/head';
import AmpHead from '../components/head/amp_head';
import FbiaHead from '../components/head/fbia_head';

import { TrackerProvider } from '../../utils/tracking/components';
import configuredTracker from '../../utils/tracking/configureTracker';

// function addMoatPrebidHeader() {
//   const moatScript = window.top.document.createElement('script');

//   moatScript.setAttribute(
//     'src',
//     'https://z.moatads.com/mansuetoprebidheader15141606144/yi.js'
//   );

//   document.head.appendChild(moatScript);
//   window.moatYieldReady = function() {
//     console.log('header script added');
//   };
// }

function Root({ store, history, getRoutes }) {
  // addMoatPrebidHeader();
  const state = store.getState();
  const amp = get(state, 'config.amp');
  const fbia = get(state, 'config.fbia');

  if (amp) {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <html amp="" lang="en-US" className="fonts-loaded">
            <AmpHead />
            {renderRoutes(getRoutes(store))}
          </html>
        </ConnectedRouter>
      </Provider>
    );
  }

  if (fbia) {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <html lang="en-US" prefix="op: http://media.facebook.com/op#">
            <FbiaHead />
            {renderRoutes(getRoutes(store))}
          </html>
        </ConnectedRouter>
      </Provider>
    );
  }

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <TrackerProvider tracker={configuredTracker}>
          <html lang="en-US">
            <Head />
            {renderRoutes(getRoutesWithStore(store))}
          </html>
        </TrackerProvider>
      </ConnectedRouter>
    </Provider>
  );
}

Root.defaultProps = {
  getRoutes: undefined
};

Root.propTypes = {
  store: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  getRoutes: PropTypes.func
};

export default Root;
